const iconsProviderConfig = {
	size: '2.4rem',
	color: 'inherit',
	style: {
		verticalAlign: 'middle',
	},
};

export default iconsProviderConfig;
